import { controls,grouped } from "../controls";
const term_deposits = {
label: "Term Deposits",
pageLabel: "Term Deposits",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
formTabs:
 {allTabs: [
{ label: "General", uid: "general" },
{label: "Td Schedule",uid: "td_schedule",fastpath:"td_schedule"}
]},
filter:[
]
,form:[
...controls.displayText({ tab: "general", label: "Scheme",star:true}),
...controls.oc({ tab: "general", c: "Scheme", placeHolder: "Scheme Code", name: "scheme_code",isRequired:true,fastpath: "schemes" ,isReadOnly:"edit" ,displayData:{interest_frequency_code:"term_deposit.interest_frequency_code"},hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "scheme_display"}),
...controls.displayText({ tab: "general", label: "Interest Frequency",star:false}),
...controls.autoComplete({tab: "general", name: "interest_frequency_code", width: "col-sm-2",controlType: "InterestFrequency",isReadOnly:true}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Receipt No",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "receipt_no",maxlength:20 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "general", label: "As On Date",target: "as_on_date",star:false}),
...controls.magicDate({ tab: "general", name: "as_on_date", dateType: "ontype" ,isReadOnly:"edit" ,default: 'n', isReadOnly: true }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Deposit Amount",star:false}),
...controls.numtoword({ tab: "general",  placeHolder: "", name: "deposit_amount",maxlength:18,width:'col-sm-2',textwidth:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Period Months",star:false,parents:[{"name": "term_deposit.interest_frequency_display", "match": "in", "reverse": "true", "value": ["Daily"]}]}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "period_months",maxlength:200,parents:[{"name": "term_deposit.interest_frequency_display", "match": "in", "reverse": "true", "value": ["Daily"]}] ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Period Days",star:false,parents:[{"name": "term_deposit.interest_frequency_display", "match": "in", "value": ["Daily"]}]}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "period_days",maxlength:200,parents:[{"name": "term_deposit.interest_frequency_display", "match": "in", "value": ["Daily"]}] ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "general", label: "Is Auto Renew",default:false, name: "is_auto_renew" ,isReadOnly:"edit"  }),
...controls.checkBox({ tab: "general", label: "Auto Renew with Interest",default:false, name: "is_auto_renew_w_interest",parents:[{"name": "term_deposit.is_auto_renew", "match": "exist", "show": "readonly"}] ,isReadOnly:"edit"  }),
...controls.displayText({ tab: "general", label: "Maturity Int Ac",star:false,parents:[{"name": "term_deposit.is_auto_renew", "match": "exist", "show": "readonly"}]}),
...controls.oc({ tab: "general", c: "Account", placeHolder: "Maturity Int Ac", name: "mat_int_account_code",fastpath: "accounts",parents:[{"name": "term_deposit.is_auto_renew", "match": "exist", "show": "readonly"}] ,isReadOnly:"edit" ,hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "mat_int_account_display",parents:[{"name": "term_deposit.is_auto_renew", "match": "exist", "show": "readonly"}]}),
...controls.displayText({ tab: "general", label: "Standing Int Ac",star:false}),
...controls.oc({ tab: "general", c: "Account", placeHolder: "Standing Int Ac", name: "std_int_account_code",fastpath: "accounts" ,isReadOnly:"edit" ,hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "std_int_account_display"}),
...controls.displayText({ tab: "general", label: "Maturity Amount",star:false}),
...controls.numtoword({ tab: "general",  placeHolder: "", name: "maturity_amount",maxlength:18,width:'col-sm-2',textwidth:"col-sm-2",isReadOnly:true}),
...controls.displayText({ tab: "general", label: "Interest Rate"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "interest_rate",maxlength:6 ,isReadOnly:"edit" ,isReadOnly:true}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Interest Payable"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "interest_payable",maxlength:18 ,isReadOnly:"edit" ,isReadOnly:true}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "general", label: "Maturity Date",target: "maturity_date",star:false}),
...controls.magicDate({ tab: "general", name: "maturity_date", dateType: "ontype" ,isReadOnly:"edit" ,isReadOnly:true }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab:"td_schedule" ,width:"col-sm-12", label: "" }),
...controls.displayText({ tab:"td_schedule" ,width:"col-sm-4", label: "" }),
...controls.displayText({ tab:"td_schedule" ,width:"col-sm-1", label: "" }),
...controls.button({
tab:"td_schedule",
 label: "Generate",
 style: { padding: 0 },
Bcolor: "success",
 onclick: {
  action: "generateTDSchedule",
  acttype: "serverfunc",
  otherdata: ["product_uid","term_deposit.scheme_uid","term_deposit.as_on_date","term_deposit.interest_frequency_uid","term_deposit.deposit_amount","term_deposit.period_months","term_deposit.period_days","term_deposit.is_auto_renew"],
  tableNameField: "td_schedule",
  requiredField: ["interest_date","days","months","amount",]
}, width: "col-sm-2"
}),
{
  tab:"td_schedule",
inputType: "table",
  tableTitle: "",
  deletable: false,
  editable: false,
  tableHeaders: [
    { label: "Sr", type: "autoinc" },
    { label: "Interest Date", field: "interest_date", displaytype: "date"},
    { label: "Days", field: "days"},
    { label: "Months", field: "months"},
    { label: "Amount", field: "amount"},
  ],
  widths: {
    parent: "col-sm-12",
    children: "col-sm-12"
  },
  name: "td_schedule"
},
]
,history:{
perPage: 10,
reportHeader: "Term Deposits",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
]}};
export default term_deposits;